import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from 'APP/wsApi/wsAppApi/WsAppApi';
import { WsRequest } from 'APP/wsApi/wsAppApi/requests/request.types';
import {
  AcceptSecretChatAccessRequestsRequest,
  AcceptSecretChatAccessRequestsRequestSchema,
  AddSecretChatParticipantsRequest,
  AddSecretChatParticipantsRequestSchema,
  CreateE2eeCommitRequest,
  CreateE2eeCommitRequestSchema,
  CreateSecretChatAccessRequestRequest,
  CreateSecretChatAccessRequestRequestSchema,
  CreateSecretChatRequest,
  CreateSecretChatRequestSchema,
  DeclineSecretChatAccessRequestsRequest,
  DeclineSecretChatAccessRequestsRequestSchema,
  GetActiveSecretChatAccessRequestsRequest,
  GetActiveSecretChatAccessRequestsRequestSchema,
  RemoveSecretChatParticipantsRequest,
  RemoveSecretChatParticipantsRequestSchema,
} from 'APP/wsApi/wsAppApi/types/chat/chat_requests_pb';
import {
  AcceptSecretChatAccessRequestsResponse,
  AddSecretChatParticipantsResponse,
  CreateE2eeCommitResponse,
  CreateSecretChatAccessRequestResponse,
  CreateSecretChatResponse,
  DeclineSecretChatAccessRequestsResponse,
  GetActiveSecretChatAccessRequestsResponse,
  RemoveSecretChatParticipantsResponse,
} from 'APP/wsApi/wsAppApi/types/chat/chat_responses_pb';
import {
  AckWelcomesRequest,
  AckWelcomesRequestSchema,
  GetCommitsRequest,
  GetCommitsRequestSchema,
  ConsumeKeyPackagesByUserIdsRequest,
  ConsumeKeyPackagesByUserIdsRequestSchema,
  GetWelcomesRequest,
  GetWelcomesRequestSchema,
  UploadKeyPackagesRequest,
  UploadKeyPackagesRequestSchema,
  GetKeyPackagesForUntrustedDeviceRequest,
  GetKeyPackagesForUntrustedDeviceRequestSchema,
  ConsumeKeyPackagesByUserIdAndDeviceIdRequest,
  ConsumeKeyPackagesByUserIdAndDeviceIdRequestSchema,
  GetKeyPackagesCountRequest,
  GetKeyPackagesCountRequestSchema,
  ClearCurrentDeviceE2eeDataRequest,
  ClearCurrentDeviceE2eeDataRequestSchema,
} from 'APP/wsApi/wsAppApi/types/encryption/encryption_requests_pb';
import {
  AckWelcomesResponse,
  GetCommitsResponse,
  ConsumeKeyPackagesByUserIdsResponse,
  GetWelcomesResponse,
  UploadKeyPackagesResponse,
  GetKeyPackagesForUntrustedDeviceResponse,
  ConsumeKeyPackagesByUserIdAndDeviceIdResponse,
  GetKeyPackagesCountResponse,
  ClearCurrentDeviceE2eeDataResponse,
} from 'APP/wsApi/wsAppApi/types/encryption/encryption_response_pb';
import { untrustedWsAppRequestManager } from 'APP/wsApi/wsAppApi/untrustedWsAppApi/UntrustedWsAppApi';

export function uploadKeyPackagesRequest(
  data: WsRequest<UploadKeyPackagesRequest>
): Promise<UploadKeyPackagesResponse> {
  return wsAppRequestManager.request<UploadKeyPackagesResponse>({
    case: 'uploadKeyPackages',
    value: create(UploadKeyPackagesRequestSchema, data),
  });
}

export function uploadKeyPackagesUntrustedRequest(
  data: WsRequest<UploadKeyPackagesRequest>
): Promise<UploadKeyPackagesResponse> {
  return untrustedWsAppRequestManager.request<UploadKeyPackagesResponse>({
    case: 'uploadKeyPackages',
    value: create(UploadKeyPackagesRequestSchema, data),
  });
}

export function consumeKeyPackagesRequest(
  data: WsRequest<ConsumeKeyPackagesByUserIdsRequest>
): Promise<ConsumeKeyPackagesByUserIdsResponse> {
  return wsAppRequestManager.request<ConsumeKeyPackagesByUserIdsResponse>({
    case: 'consumeKeyPackagesByUserIds',
    value: create(ConsumeKeyPackagesByUserIdsRequestSchema, data),
  });
}

export function consumeKeyPackagesByUserIdAndDeviceIdRequest(
  data: WsRequest<ConsumeKeyPackagesByUserIdAndDeviceIdRequest>
): Promise<ConsumeKeyPackagesByUserIdAndDeviceIdResponse> {
  return wsAppRequestManager.request<ConsumeKeyPackagesByUserIdAndDeviceIdResponse>({
    case: 'consumeKeyPackagesByUserIdAndDeviceId',
    value: create(ConsumeKeyPackagesByUserIdAndDeviceIdRequestSchema, data),
  });
}

export function createSecretChatRequest(
  data: WsRequest<CreateSecretChatRequest>
): Promise<CreateSecretChatResponse> {
  return wsAppRequestManager.request<CreateSecretChatResponse>({
    case: 'createSecretChat',
    value: create(CreateSecretChatRequestSchema, data),
  });
}

export function addSecretChatParticipantsRequest(
  data: WsRequest<AddSecretChatParticipantsRequest>
): Promise<AddSecretChatParticipantsResponse> {
  return wsAppRequestManager.request<AddSecretChatParticipantsResponse>({
    case: 'addSecretChatParticipants',
    value: create(AddSecretChatParticipantsRequestSchema, data),
  });
}

export function removeSecretChatParticipantsRequest(
  data: WsRequest<RemoveSecretChatParticipantsRequest>
): Promise<RemoveSecretChatParticipantsResponse> {
  return wsAppRequestManager.request<RemoveSecretChatParticipantsResponse>({
    case: 'removeSecretChatParticipants',
    value: create(RemoveSecretChatParticipantsRequestSchema, data),
  });
}

export function getWelcomesRequest(
  data: WsRequest<GetWelcomesRequest>
): Promise<GetWelcomesResponse> {
  return wsAppRequestManager.request<GetWelcomesResponse>({
    case: 'getWelcomes',
    value: create(GetWelcomesRequestSchema, data),
  });
}

export function ackWelcomesRequest(
  data: WsRequest<AckWelcomesRequest>
): Promise<AckWelcomesResponse> {
  return wsAppRequestManager.request<AckWelcomesResponse>({
    case: 'ackWelcomes',
    value: create(AckWelcomesRequestSchema, data),
  });
}

export function getCommitsRequest(data: WsRequest<GetCommitsRequest>): Promise<GetCommitsResponse> {
  return wsAppRequestManager.request<GetCommitsResponse>({
    case: 'getCommits',
    value: create(GetCommitsRequestSchema, data),
  });
}

export function getKeyPackagesForUntrustedDeviceRequest(
  data: WsRequest<GetKeyPackagesForUntrustedDeviceRequest>
): Promise<GetKeyPackagesForUntrustedDeviceResponse> {
  return wsAppRequestManager.request<GetKeyPackagesForUntrustedDeviceResponse>({
    case: 'getKeyPackagesForUntrustedDevice',
    value: create(GetKeyPackagesForUntrustedDeviceRequestSchema, data),
  });
}

export function createCommitRequest(
  data: WsRequest<CreateE2eeCommitRequest>
): Promise<CreateE2eeCommitResponse> {
  return wsAppRequestManager.request<CreateE2eeCommitResponse>({
    case: 'createE2eeCommit',
    value: create(CreateE2eeCommitRequestSchema, data),
  });
}

export function createSecretChatRequestAccessRequest(
  data: WsRequest<CreateSecretChatAccessRequestRequest>
): Promise<CreateSecretChatAccessRequestResponse> {
  return wsAppRequestManager.request<CreateSecretChatAccessRequestResponse>({
    case: 'createSecretChatAccessRequest',
    value: create(CreateSecretChatAccessRequestRequestSchema, data),
  });
}

export function getActiveSecretChatAccessRequestsRequest(
  data: WsRequest<GetActiveSecretChatAccessRequestsRequest>
): Promise<GetActiveSecretChatAccessRequestsResponse> {
  return wsAppRequestManager.request<GetActiveSecretChatAccessRequestsResponse>({
    case: 'getActiveSecretChatAccessRequests',
    value: create(GetActiveSecretChatAccessRequestsRequestSchema, data),
  });
}

export function acceptSecretChatAccessRequestsRequest(
  data: WsRequest<AcceptSecretChatAccessRequestsRequest>
): Promise<AcceptSecretChatAccessRequestsResponse> {
  return wsAppRequestManager.request<AcceptSecretChatAccessRequestsResponse>({
    case: 'acceptSecretChatAccessRequests',
    value: create(AcceptSecretChatAccessRequestsRequestSchema, data),
  });
}

export function declineSecretChatAccessRequestsRequest(
  data: WsRequest<DeclineSecretChatAccessRequestsRequest>
): Promise<DeclineSecretChatAccessRequestsResponse> {
  return wsAppRequestManager.request<DeclineSecretChatAccessRequestsResponse>({
    case: 'declineSecretChatAccessRequests',
    value: create(DeclineSecretChatAccessRequestsRequestSchema, data),
  });
}

export function getKeyPackagesCountRequest(
  data: WsRequest<GetKeyPackagesCountRequest>
): Promise<GetKeyPackagesCountResponse> {
  return wsAppRequestManager.request<GetKeyPackagesCountResponse>({
    case: 'getKeyPackagesCount',
    value: create(GetKeyPackagesCountRequestSchema, data),
  });
}

export function clearCurrentDeviceE2eeDataRequest(
  data: WsRequest<ClearCurrentDeviceE2eeDataRequest>
): Promise<ClearCurrentDeviceE2eeDataResponse> {
  return wsAppRequestManager.request<ClearCurrentDeviceE2eeDataResponse>({
    case: 'clearCurrentDeviceE2eeData',
    value: create(ClearCurrentDeviceE2eeDataRequestSchema, data),
  });
}
